// Copyright (c) PikPok. All rights reserved
import Vapi from "vuex-rest-api"


const supportStore = new Vapi({
    baseURL: window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' ? 'http://127.0.0.1:6789' : window.location.origin,
    queryParams: true,
    state: {
        localeKeys: [],
        bugReport: [],
        consent: []
    }
})
    .get({
        action: 'getLocaleKeys',
        property: 'localeKeys',
        path: '/support/home',
    })
    .get({
        action: 'getBugReport',
        property: 'bugReport',
        path: '/support/bugreport',
    })
    .post({
        action: 'postBugReport',
        path: '/support/bugreport',
    })
    .post({
        action: 'postPrivacyForm',
        path: '/support/privacy',
    })
    .get({
        action: 'getConsent',
        property: 'consent',
        path: '/support/consent',
    })
    .post({
        action: 'postConsent',
        path: '/support/consent',
    })
    .getStore()

export {supportStore}